<template>
  <q-card-section>
    <q-card-section horizontal class="flex flex-center no-padding">
      <q-input dir="ltr" filled v-model="localStartDate" mask="date" :rules="['date']"
               label="تاریخ شروع" clearable class="q-mr-xs">
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
              <q-date v-model="localStartDate" calendar="persian">
                <div class="row items-center justify-center">
                  <q-btn v-close-popup label="تایید" color="primary" flat/>
                  <q-btn v-close-popup @click="localStartDate = ToJalaliDate(new Date())" label="امروز"
                         color="primary"
                         flat/>
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
      <q-input dir="ltr" filled v-model="localEndDate" mask="date" :rules="['date']"
               label="تاریخ پایان" clearable>
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
              <q-date v-model="localEndDate" calendar="persian">
                <div class="row items-center justify-center">
                  <q-btn v-close-popup label="تایید" color="primary" flat
                  />
                  <q-btn v-close-popup @click="localEndDate = ToJalaliDate(new Date())" label="امروز"
                         color="primary"
                         flat/>
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </q-card-section>
    <q-card-actions align="center" class="no-padding q-gutter-xs">
      <q-btn color="indigo" label="گزارشات" icon="receipt_long"
             @click="$emit('show-comments', {startDate: localStartDate,endDate: localEndDate, targetId: undefined, salePrice:undefined})"/>
    </q-card-actions>
  </q-card-section>
</template>

<script>
export default {
  name: "SelectDateRange",
  props: {
  },
  data() {
    return {
      localStartDate: this.ToJalaliDate(new Date()),
      localEndDate: this.ToJalaliDate(new Date())
    }
  },
  methods:{
    async loadSaleManagerReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مدیر فروش/داشبورد وضعیت ماه?rs:Format=PDF&StartDate=${this.selectedTarget.AuditStartDate}&EndDate=${this.selectedTarget.AuditEndDate}&rc:Parameters=False&rc:Zoom=Page Width`)
    }
  }
}
</script>

<style scoped>

</style>